import styled, { css } from 'styled-components';
import CallToAction from 'contentful/shared/call_to_action';
import RTECompose from 'contentful/RTE_compose';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';
import Container from './shared/container';

const TextSection = ({
  fields: {
    title,
    content,
    callToActions,
    backgroundColor,
    alignment: textAlignment = 'left',
    sectionAlignment = 'left',
  },
  ...rest
}) => (
  <Section
    backgroundColor={backgroundColor}
    hasReducedPadding
    textAlignment={textAlignment}
    sectionAlignment={sectionAlignment}
    {...rest}>
    <TextWrapper>
      {title && <Title>{title}</Title>}
      {content && <RTECompose content={content} fieldType="content" />}
      {callToActions?.length > 0 && (
        <Actions
          isCenter={
            textAlignment === 'center' && sectionAlignment === 'center'
          }>
          {callToActions.map(({ sys: { id }, fields }) => (
            <CallToAction id={id} key={id} content={fields} newTab />
          ))}
        </Actions>
      )}
    </TextWrapper>
  </Section>
);

const Section = styled(Container)`
  ${({ textAlignment, sectionAlignment }) =>
    sectionAlignment === 'center' &&
    css`
      text-align: ${textAlignment};
      display: flex;
      justify-content: center;

      ${textAlignment === 'center' &&
      css`
        ul {
          max-width: 600px;
          margin-inline: auto;
          text-align: left;
        }
      `}
    `}
`;

const TextWrapper = styled.div`
  max-width: 768px;

  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit;
  }
`;

const Title = styled.h2`
  font-size: ${toRem(36)};
  margin-bottom: ${toRem(32)};

  ${responsive('tabletSmall')} {
    font-size: ${toRem(40)};
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: ${({ isCenter }) => (isCenter ? 'center' : 'start')};
  flex-direction: column;
  margin-top: ${toRem(56)};
  gap: ${toRem(16)};

  ${responsive('phoneLarge')} {
    flex-direction: row;
  }
`;

export default TextSection;
